import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition, HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  AdsTxtUpdatedEnvelope,
  AppendAdsTxtOptions,
  AppendAdsTxtResponse,
  GetAdsTxtOptions,
  GetAdsTxtResponse,
  UpdateAdsTxtOptions,
  UpdateAdsTxtResponse,
  appendAdsTxt as universalAppendAdsTxt,
  getAdsTxt as universalGetAdsTxt,
  updateAdsTxt as universalUpdateAdsTxt,
} from './promote-marketing-v2-ads-txt-ads-txt.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/marketing' };

export function getAdsTxt(httpClient: HttpClient): GetAdsTxtSignature {
  return (options?: GetAdsTxtOptions) =>
    universalGetAdsTxt(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetAdsTxtSignature {
  /**
   * Retrieves the Ads.txt file.
   * @returns The response of the Ads.txt file request
   */
  (options?: GetAdsTxtOptions): Promise<
    NonNullablePaths<
      GetAdsTxtResponse,
      `adsTxt.content` | `adsTxt.default` | `adsTxt.subdomain`,
      3
    >
  >;
}

export function updateAdsTxt(httpClient: HttpClient): UpdateAdsTxtSignature {
  return (options?: UpdateAdsTxtOptions) =>
    universalUpdateAdsTxt(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateAdsTxtSignature {
  /**
   * Updates the Ads.txt file.
   * When setting the `content` object to an empty string, an empty Ads.txt file will be created.
   * In order to reset Ads.txt to Wix's default, send `default: true` without a `content` object.
   */
  (options?: UpdateAdsTxtOptions): Promise<
    NonNullablePaths<
      UpdateAdsTxtResponse,
      `adsTxt.content` | `adsTxt.default` | `adsTxt.subdomain`,
      3
    >
  >;
}

export function appendAdsTxt(httpClient: HttpClient): AppendAdsTxtSignature {
  return (options?: AppendAdsTxtOptions) =>
    universalAppendAdsTxt(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface AppendAdsTxtSignature {
  /**
   * Appends the submitted `content` object to Ads.txt.
   * In order to reset Ads.txt to Wix's default, send `default: true` without a `content` object.
   */
  (options?: AppendAdsTxtOptions): Promise<
    NonNullablePaths<
      AppendAdsTxtResponse,
      `adsTxt.content` | `adsTxt.default` | `adsTxt.subdomain`,
      3
    >
  >;
}

export const onAdsTxtUpdated = /*#__PURE__*/ EventDefinition(
  'wix.promote.marketing.ads_txt_updated',
  true,
  (event: AdsTxtUpdatedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [{ path: 'metadata.eventTime' }],
        },
      ])
    )
)<AdsTxtUpdatedEnvelope>();

export {
  AccountInfo,
  AccountInfoMetadata,
  ActionEvent,
  AdsTxt,
  AdsTxtUpdatedEnvelope,
  AppendAdsTxtOptions,
  AppendAdsTxtRequest,
  AppendAdsTxtResponse,
  BaseEventMetadata,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  EventMetadata,
  GetAdsTxtOptions,
  GetAdsTxtRequest,
  GetAdsTxtResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  RestoreInfo,
  UpdateAdsTxtOptions,
  UpdateAdsTxtRequest,
  UpdateAdsTxtResponse,
  WebhookIdentityType,
} from './promote-marketing-v2-ads-txt-ads-txt.universal.js';
